import React from "react";

import FullPageLayout from "../../layouts/FullPage";
import BigMessage from "../../components/BigMessage";
import image from "./broken-car-replacement.jpg";

const ServerError = () => (
  <FullPageLayout backgroundImage={image}>
    <BigMessage
      title="Something went wrong"
      subtitle="Please come back later and try again"
    />
  </FullPageLayout>
);

export default ServerError;
